export default function MySQL_MAX() {
  return (
    <div>
      <h2>MySQL_MAX</h2>    </div>
  );
}